{
  "lastUpdatedAt": "2026-08-26T14:23:45.200Z",
  "lastFetchAttemptAt": "2026-08-26T14:23:45.200Z",
  "organization": null,
  "parseError": null,
  "fetchError": null
}